// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const REPLY_LINK = "Odpov\u011bz";
